import { useFlowFilter } from './FlowFilterContext'
import type { Audience, Variant } from '../types'

interface FlowOption {
  label: string
  audience: Audience | 'all'
  variant: Variant | 'all'
}

const FLOW_OPTIONS: FlowOption[] = [
  { label: 'Alle', audience: 'all', variant: 'all' },
  { label: 'Unge', audience: 'unge', variant: 'all' },
  { label: 'Ældre', audience: 'aeldre', variant: 'all' },
  { label: 'Chat – Unge', audience: 'unge', variant: 'chat' },
  { label: 'Beregner – Unge', audience: 'unge', variant: 'calculator' },
  { label: 'Chat – Ældre', audience: 'aeldre', variant: 'chat' },
  { label: 'Beregner – Ældre', audience: 'aeldre', variant: 'calculator' },
]

export function FlowFilter() {
  const { audience, variant, setAudience, setVariant } = useFlowFilter()
  return (
    <div className="flow-filter-group" aria-label="Flow filter">
      <div className="flow-filter" role="tablist" aria-label="Flow">
        <span className="flow-filter-label" aria-hidden="true">Flow</span>
        {FLOW_OPTIONS.map((o) => {
          const active = audience === o.audience && variant === o.variant
          return (
            <button
              key={`${o.audience}-${o.variant}`}
              role="tab"
              aria-selected={active}
              className={`flow-tab ${active ? 'active' : ''}`}
              onClick={() => { setAudience(o.audience); setVariant(o.variant) }}
            >{o.label}</button>
          )
        })}
      </div>
    </div>
  )
}
